import System from 'src/helper/system';

class ResponseMaker {
    data = [];
    data_to_send = {
        accountInformation: {}
    };

    constructor(data) {
        this.data = data;
    }

    process = async () => {
        if (this.data) {
            this.data_to_send.accountInformation = this.data
            if (this.data.firstName) {
                this.data_to_send.accountInformation.fullName = (this.data.firstName) + ' ' + (this.data.middleName ? this.data.middleName : '') + ' ' + (this.data.lastName ? this.data.lastName : '')
            }
            this.data_to_send.accountInformation.company = this.data.company ? this.data.company : ''
            this.data_to_send.accountInformation.jobFunction = this.data.jobFunction ? this.data.jobFunction : ''
            this.data_to_send.accountInformation.phoneNumber = this.data.phoneNumber ? this.data.phoneNumber : ''
            this.data_to_send.accountInformation.accountNumber = System.auth('accountNumber') ? System.auth('accountNumber') + (System.auth('salesOrg') ? '-' + System.auth('salesOrg') : '') : ''
        }

        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}

export default ResponseMaker;